import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

export default function CustomAnimation({ children, delay = 0, duration = 1500, distance = "40px" }) {
  const customAnimation = keyframes`
      from {
        opacity: 0;
        transform: translateY(${distance});
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    `;

  return (
    <Reveal keyframes={customAnimation} duration={duration} triggerOnce delay={delay}>
      {children}
    </Reveal>
  );
}
